import API from "../../services/api";

export const fetchIamDashboard = async () => {
  const { data } = await API.get("/iam/dashboard");
  return data;
};

export const fetchIamCatalog = async () => {
  const { data } = await API.get("/iam/catalog");
  return data;
};

export const seedIam = async () => {
  const { data } = await API.post("/iam/seed");
  return data;
};

export const fetchIamUsers = async (params = {}) => {
  const { data } = await API.get("/iam/users", { params });
  return data;
};

export const inviteIamUser = async (payload) => {
  const { data } = await API.post("/iam/users/invite", payload);
  return data;
};

export const bulkIamUsers = async (payload) => {
  const { data } = await API.post("/iam/users/bulk", payload);
  return data;
};

/** Admin: assign/replace roles — updates user_roles + users.role in DB */
export const setUserAccess = async (payload) => {
  const { data } = await API.put("/iam/users/access", payload);
  return data;
};

export const fetchIamRoles = async () => {
  const { data } = await API.get("/iam/roles");
  return data;
};

export const createIamRole = async (payload) => {
  const { data } = await API.post("/iam/roles", payload);
  return data;
};

export const updateIamRole = async (roleId, payload) => {
  const { data } = await API.put(`/iam/roles/${roleId}`, payload);
  return data;
};

export const updateRoleHierarchy = async (items) => {
  const { data } = await API.put("/iam/roles/hierarchy", { items });
  return data;
};

export const fetchPermissionGroups = async () => {
  const { data } = await API.get("/iam/permission-groups");
  return data;
};

export const createPermissionGroup = async (payload) => {
  const { data } = await API.post("/iam/permission-groups", payload);
  return data;
};

export const updatePermissionGroup = async (groupId, payload) => {
  const { data } = await API.put(`/iam/permission-groups/${groupId}`, payload);
  return data;
};

export const fetchRoleAccessBlueprint = async () => {
  const { data } = await API.get("/iam/role-access-blueprint");
  return data;
};

export const updateRoleAccess = async (roleSlug, payload) => {
  const { data } = await API.put(`/iam/role-access/${roleSlug}`, payload);
  return data;
};

export const seedRoleAccessDefaults = async () => {
  const { data } = await API.post("/iam/role-access/seed-defaults");
  return data;
};

export const fetchWorkflows = async () => {
  const { data } = await API.get("/iam/workflows");
  return data;
};

export const createWorkflow = async (payload) => {
  const { data } = await API.post("/iam/workflows", payload);
  return data;
};

export const fetchPolicies = async () => {
  const { data } = await API.get("/iam/policies");
  return data;
};

export const createPolicy = async (payload) => {
  const { data } = await API.post("/iam/policies", payload);
  return data;
};

export const fetchSessions = async () => {
  const { data } = await API.get("/iam/sessions");
  return data;
};

export const revokeSession = async (sessionId) => {
  const { data } = await API.post(`/iam/sessions/${sessionId}/revoke`);
  return data;
};

export const fetchAuditLogs = async (limit = 100) => {
  const { data } = await API.get("/iam/audit-logs", { params: { limit } });
  return data;
};

export const fetchSecuritySettings = async () => {
  const { data } = await API.get("/iam/security-settings");
  return data;
};

export const updateSecuritySettings = async (payload) => {
  const { data } = await API.patch("/iam/security-settings", payload);
  return data;
};

export const fetchAccessScopes = async (search) => {
  const { data } = await API.get("/iam/access-scopes", { params: search ? { search } : {} });
  return data;
};

export const fetchAccessScopeCatalog = async () => {
  const { data } = await API.get("/iam/access-scopes/catalog");
  return data;
};

export const saveAccessScope = async (userId, payload) => {
  const { data } = await API.put(`/iam/access-scopes/${userId}`, payload);
  return data;
};

export const setAccessScopeStatus = async (userId, isActive) => {
  const { data } = await API.post(`/iam/access-scopes/${userId}/status`, { is_active: isActive });
  return data;
};

export const resetAccessScope = async (userId) => {
  const { data } = await API.delete(`/iam/access-scopes/${userId}`);
  return data;
};

export const resetIamUserPassword = async (userId) => {
  const { data } = await API.post(`/iam/users/${userId}/reset-password`);
  return data;
};
